import React, { useState } from 'react';
import { Tooltip } from 'ui/tooltip';
import { DatePickerWrapper } from './DatePickerInput.styles';
import { checkIfAllInputsAreValid } from '../helpers';

// type DatePickerInputProps = {
//   children: React.ReactNode,
//   /** Class name, used for overriding styles */
//   className?: string,
//   /** Applies disabled styles */
//   isDisabled?: boolean,
//   /** Inputs to be displayed in this wrapper component */
//   isInvalidRange?: boolean,
//   /** On click handler */
//   onClick?: () => void,
//   /** Whether datepicker has error */
//   hasError?: boolean,
// };
/**
 * DatePickerInputProps
 * @param {any} children
 * @param {string=} className
 * @param {boolean=} isDisabled
 * @param {boolean=} isInvalidRange
 * @param {boolean=} hasError
 * @param {() => void=} onClick
 */
export const DatePickerInput = ({
  children,
  className,
  isInvalidRange,
  hasError = false,
  isDisabled = false,
  ...props
}) => {
  const [inputs, setInputs] = useState({});
  const handleEntryChange = (newInput) => {
    setInputs({ ...inputs, ...newInput });
  };

  return (
    <DatePickerWrapper
      as="form"
      className={className}
      isDisabled={isDisabled}
      isValid={!hasError && !isInvalidRange && checkIfAllInputsAreValid(inputs)}
      {...props}
    >
      <Tooltip
        tooltipContent="Please select an end time that is after the starting time."
        isEnabled={!!isInvalidRange}
      >
        {React.Children.toArray(children).map((node) =>
          React.cloneElement(node, {
            onEntryChange: handleEntryChange,
            ...(isDisabled ? { isReadOnly: true } : {}),
            ...node.props,
          }),
        )}
      </Tooltip>
    </DatePickerWrapper>
  );
};
